import { SchedulerV3 } from '@frontend/api-schedule-v3';

// SP-TODO: temporary re-exporting to avoid chaning import everywhere, need to refactor later
export type CalendarEventsEnums = SchedulerV3.Types.CalendarEventsEnums;
export const CalendarEventsEnums = SchedulerV3.Types.CalendarEventsEnums;
export type CalendarEventType = SchedulerV3.Types.CalendarEventType;

export type ExceptionEventParams = {
  name: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  isAvailable: boolean;
  id: string;
};

export enum ScheduleMassMessageStepEnum {
  SELECT_PATIENTS_TO_CONTACT = 'SELECT_PATIENTS_TO_CONTACT',
  SEND_MASS_MESSAGE = 'SEND_MASS_MESSAGE',
}
